const InputType = Object.freeze({
  RADIO: 'RADIO',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
  CHECKBOX: 'CHECKBOX',
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA'
})

export default InputType